import { twMerge } from '@panwds/tailwindcss';
export const TopNavV3Classes = {
    root: {
        box: 'twds-box-border',
        display: 'twds-flex',
        layout: 'twds-flex-col',
        dimension: 'twds-min-h-0'
    },
    ul: {
        overflow: 'twds-overflow-y-auto  twds-overflow-x-hidden',
        scrollbar: 'twds-scrollbar-small twds-scrollbar-no-track dark:twds-scrollbar-thumb-dark dark:twds-scrollbar-corner-dark',
        box: 'twds-box-border',
        list: 'twds-list-none',
        spacing: 'twds-m-0 twds-p-0 twds-b-0'
    }
};
export function getTopNavRootClasses(className) {
    return twMerge(TopNavV3Classes.root.box, TopNavV3Classes.root.display, TopNavV3Classes.root.layout, TopNavV3Classes.root.dimension, className);
}
export function getTopNavListClasses(className) {
    return twMerge(TopNavV3Classes.ul.box, TopNavV3Classes.ul.overflow, TopNavV3Classes.ul.scrollbar, TopNavV3Classes.ul.list, TopNavV3Classes.ul.spacing, className);
}
//# sourceMappingURL=topNavV3.logic.js.map